import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { SigilProvider } from "@engagexp/legendary-ui";
import { AppHeader } from "~/app/components/AppHeader";
import { AppFooter } from "~/app/components/AppFooter";
import { CommandPalette } from "~/app/components/CommandPalette";
import { ErrorBoundary } from "~/app/components/ErrorBoundary";

function LoadingFallback() {
  return (
    <div className="min-h-screen bg-[var(--background)] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
        <span
          style={{ fontSize: 14, fontWeight: 500 }}
          className="text-[var(--muted-foreground)]"
        >
          Loading...
        </span>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => (
    <ErrorBoundary>
      <SigilProvider theme="engagexp">
        <Suspense fallback={<LoadingFallback />}>
          <AppHeader />
          <CommandPalette />
          <main>
            <Outlet />
          </main>
          <AppFooter />
        </Suspense>
      </SigilProvider>
    </ErrorBoundary>
  ),
});
